import React from 'react';
import PropTypes from 'prop-types';
import { get, flow, find, defaultTo } from 'lodash/fp';

import ItemAttributes from '../ItemAttributes/ItemAttributesConnector';
import EditAttributes from './EditAttributes';
import RenameItemButton from '../RenameItemButtonConnector';
import itemAttributeShape from '../../../../../prop-types/itemAttributeShape';
import checkForNewWindowLabels from '../../../../../helpers/checkForNewWindowLabel';

import {
  CenteredWindowDimensionsVisualizer,
  CenteredWindowRatioDefaultIcon,
  HeaderLabel,
  HeaderName,
  HeaderEdit,
  ItemHeader,
} from './styles';

const ItemDetails = ({
  isMandi,
  itemIndex,
  name,
  isLockedOrOrdered,
  itemId,
  attributes,
  isInternalUser,
  itemProduct,
  windowLabel,
}) => {
  const findAttributeValue = attrName =>
    flow(
      find({ name: attrName }),
      defaultTo(flow(
        get('attributes'),
        find(it => it.name.toLowerCase() === attrName),
      )(itemProduct)),
      get('value'),
    )(attributes);

  const widthAttribute = findAttributeValue('width');
  const heightAttribute = findAttributeValue('height');
  const windowName = checkForNewWindowLabels(windowLabel, name, itemId);

  const hasDimensions = widthAttribute && heightAttribute;

  return (
    <div className="itemDetails">
      <ItemHeader>
        <HeaderLabel>{itemIndex}</HeaderLabel>
        <HeaderName>{windowName}</HeaderName>
        {!isLockedOrOrdered && !isMandi && (
          <HeaderEdit>
            <RenameItemButton itemId={itemId} />
          </HeaderEdit>
        )}
      </ItemHeader>
      {hasDimensions && (
        <CenteredWindowDimensionsVisualizer
          width={parseFloat(widthAttribute)}
          height={parseFloat(heightAttribute)}
        />
      )}
      {!hasDimensions && <CenteredWindowRatioDefaultIcon />}
      {isInternalUser && isMandi && <EditAttributes itemId={itemId} />}
      {isMandi && attributes.length > 0 && (
      <ItemAttributes
        itemId={itemId}
        attributes={attributes}
      />
      )}
    </div>
  );
};

ItemDetails.propTypes = {
  isMandi: PropTypes.bool,
  itemIndex: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isLockedOrOrdered: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  attributes: PropTypes.arrayOf(itemAttributeShape).isRequired,
  isInternalUser: PropTypes.bool.isRequired,
  itemProduct: PropTypes.shape({}),
  windowLabel: PropTypes.shape({}).isRequired,
};

ItemDetails.defaultProps = {
  isMandi: false,
  itemProduct: null,
};

export default ItemDetails;
